// Loghi dello slider clienti (/assets/img/{mode}/work-with-us/{nome}.svg)
export const CLIENT_LOGOS = [
    'telepass-logo',
    'ibm-logo',
    'campari-logo',
    'poke-house-logo',
    'dxc-logo',
    'tinexta-group-logo',
    'enel-logo',
    'eni-logo',
    'cosmico-logo',
    'thomson-reuters-foundation-logo',
    'trenitalia-logo',
    'app-io-logo',
    'snai-logo',
    'snam-logo',
    'tim-logo',
    'manitese-logo',
    'nutribees-logo',
    'prestat-logo',
    'eclittica-logo',
    'motork-logo',
    'moak-logo',
    'nurale-logo',
    'numbers-logo',
    'eatsready-logo',
    'steve-jobs-academy-logo',
    'leonardo-logo'
] as const;

export type ClientLogo = typeof CLIENT_LOGOS[number];
